






































































































import { defineComponent, reactive, ref } from '@vue/composition-api';
import  cardTem  from '@components/CardModel/index';
import  TitleModel  from '@components/TitleModel/index';
import Pagination from '@/components/Pagination';
import { Button, MessageBox } from 'element-ui';
import request from '@utils/request';
import addComma from '@/utils/addComma';
import { isCore, userInfor as userInfoRef } from '@/useable/login';
const userInfor = userInfoRef.value;

export default defineComponent({
  name: 'Home',
  components: {
    cardTem,
    TitleModel,
    Pagination,
    'el-button': Button
  },
  setup(props: any, { root }: any) {
    const loginstatus = ref(false);
    const noticeList: any = ref([]);
    const noReadPage: any = ref(0);
    const cardData = ref([
      {title:'已注册供应商:', num:'', cardstyle:'home', Mtop: 24},
      {title:'累计应收账款融资供应商:', num:'', cardstyle:'home',  Mtop: 24},
      {title:'累计供应商应收账款融资情况:', num:'0', introduce:'', cardstyle:'money'},
      // {title:'银行可用额度:', num:'0', introduce:'', cardstyle:'money'}
    ]);
    const supplierData = ref([
      {title:'当月应收情况:', num:'0', introduce:'', cardstyle:'money'},
      {title:'当月融资情况:', num:'0', introduce:'', cardstyle:'money'},
      {title:'当月融资成本:', num:'0', Mtop: 24, cardstyle:'money', tipInfo: '根据本系统中记录的用户申请融资的数据计算'},
      // {title:'可用融资额度:', num:'0', introduce:'', cardstyle:'money'}
    ]);
    const getNotice = async () => {
      const res = await request('home', 'getNotice', {});
      if (res.code === 2000) {
        noticeList.value = res.data.notices;
        const page = noticeList.value.length;
        noReadPage.value = page;
        while (noticeList.value.length > 0) {
          const noticeItem: any = noticeList.value.shift();
          await MessageBox({
            title: '系统公告',
            message: `<pre>${noticeItem.content}</pre><div class="notice-page">${page-noticeList.value.length}/${page}<span class="no-read">共${noReadPage.value}条未读</span></div>`,
            dangerouslyUseHTMLString: true,
            // center: true,
            customClass: 'notice-dialog-box',
            confirmButtonClass: 'blue btn-sm',
            closeOnClickModal: false,
          }).then(()=> {
            noReadPage.value = noReadPage.value - 1;
            request('home', 'confirmNotice', {id: noticeItem.id});
          }).catch(()=>{});
        }
      }
    };
    const getBillOrderInfo = async () => {
      const res = await request('home', 'getBillOrderInfo', {
      });
      if (res.code === 2000) {
        suppliertabledata.value.data = res.data;
      }
    };
    const getFinanceOrderInfo = async () => {
      const res = await request('home', 'getFinanceOrderInfo', {
      });
      if (res.code === 2000) {
        if (!isCore.value){
          // const availableRes = res.data.supFinancingAttachInfoVo.availableFinancingCreditVo;
          const receivableRes = res.data.supFinancingAttachInfoVo.currentMonthReceivableVo;
          const financingInfoRes = res.data.supFinancingAttachInfoVo.currentMonthFinancingInfoVo;
          const financingCost = res.data.supFinancingAttachInfoVo.nowMonthFinancingCost;
          supplierData.value[0].num = `${putComma(receivableRes.cmrtotalAmount)}元`;
          supplierData.value[0].introduce = `${receivableRes.cmrcount}笔`;
          supplierData.value[1].num = `${putComma(financingInfoRes.cmfinancingTotalAmount)}元`;
          supplierData.value[1].introduce = `${financingInfoRes.cmfinancingCount}笔`;
          supplierData.value[2].num = `${putComma(financingCost)}元`;
          // supplierData.value[3].num = `${putComma(availableRes.availableFinancingCredit)}元`;
          // supplierData.value[3].introduce = `已用${Number(availableRes.usedPercentage).toFixed(2)}%`;
          tableConfig.value.data = res.data.financeOrderApplyVoList;
        } else {
          const result = res.data.corFinancingAttachInfoVo;
          cardData.value[0].num = `${result.registerSupplier}家`;
          cardData.value[1].num = `${result.totalFinancingsupplier}家`;
          cardData.value[2].introduce = `${result.nowMonthSupFinancingInfoCount}笔`;
          cardData.value[2].num = `${putComma(result.nowMonthSupFinancingInfoTotalAmount)}元`;
          // cardData.value[3].num = `${putComma(result.bankAvailableCredit)}元`;
          // cardData.value[3].introduce = `已用${Number(result.usedPercentage).toFixed(2)}%`;
          tableConfig.value.data = res.data.financeOrderApplyVoList;
        }
      }
    };
    let isGetNotice = false;
    if (!isGetNotice) {
      getNotice();
      isGetNotice = true;
    }
    if (isCore.value){
      const statisticRoute = root.$router.options.routes.find(i=>i.name === 'DataStatistics');
      statisticRoute.meta.title = '分析视图';
      statisticRoute.children.find(i=>i.name === 'Financing').meta.title = '应收账款融资';

      loginstatus.value = true;
      getFinanceOrderInfo();
    } else {
      loginstatus.value = false;
      getBillOrderInfo();
      getFinanceOrderInfo();
    }

    const financingBill = reactive(
      {title:'近期融资单', imageType:'text', more:true, urlPath: '/financing/search'}
    );
    const recentpaymentslip = reactive(
      {title:'近期付款单', imageType:'text', more:true,  urlPath: '/bill/list'}
    );
    const financingProcess = reactive(
      {title:'融资流程', imageType:'process', more:false}
    );
    const tableConfig = ref({
      'column': [
        {key: 'applyNo', label: '融资申请单号', width: 150},
        {key: 'orderType', label: '付款单类型', width: 100},
        {key: 'orderNo', label: '付款单号', width: 210},
        {key: 'payCorpName', label: '付款企业', width: 150},
        {key: 'supplierName', label: '融资供应商名称', width: 160},
        {key: 'totalAmount', label: '可融资金额', custom: true, width: 130, align: 'right', headerAlign: 'right'},
        {key: 'applyAmount', label: '申请融资金额', custom: true, width: 130, align: 'right', headerAlign: 'right'},
        {key: 'currency', label: '币种', width: 70},
        {key: 'bankName', label: '融资银行', width: 110},
        {key: 'applyPersonName', label: '申请人'},
        {key: 'applyStatus', label: '融资申请单状态', width: 120},
        {key: 'c', label: '操作', operate: true, width: 90}
      ],
      'data': []
    });
    const suppliertabledata = ref({
      'column': [
        {key: 'payCorpName', label: '付款企业'},
        {key: 'supplierName', label: '收款企业'},
        {key: 'orderNo', label: '付款单号', width: 210},
        {key: 'amount', label: '付款金额', width: 130, custom: true, align: 'right', headerAlign: 'right' },
        {key: 'currency', label: '币种', width: 70},
        {key: 'orderType', label: '付款类型', width: 100},
        {key: 'orderStatus', label: '付款单状态', width: 110},
        {key: 'planPayTime', label: '预计付款日期', width: 110},
        {key: 'c', label: '操作', operate: true, width: 90}
      ],
      'data': []
    });
    const clickMore = ( url ) => {
      root.$router.push({
        path: url
      });
    };
    const putComma = (val) => {
      const str = val.toString();
      const reg = str.indexOf('.') > -1 ? /(\d)(?=(\d{3})+\.)/g : /(\d)(?=(?:\d{3})+$)/g;
      return str.replace(reg, '$1,');
    };
    const checkBillDetail = (data) => {
      // root.$router.push({
      //   name:'billDetail',
      //   params: {
      //     id: data
      //   }
      // });
      const routeUrl = root.$router.resolve(`/bill/detail/${data}`);
      window.open(routeUrl.href, '_blank');
    };
    const checkfinancingDetail = (row) => {
      // root.$router.push(`financing/detail/${data}`);
      let routeUrl;
      if ( row.applyStatus === '草稿(第二步)' && !isCore.value && row.applyPersonWEmail === userInfor.workEmail) {
        routeUrl = root.$router.resolve({
          path: 'financing/edit/editTwo',
          query: {
            financeOrderApplyId: row.financeOrderApplyId
          }
        });
        
      } else if ( row.applyStatus === '草稿(第三步)' && !isCore.value && row.applyPersonWEmail === userInfor.workEmail) {
        routeUrl = root.$router.resolve(`financing/edit/editThree/${row.financeOrderApplyId}`);
      } else {
        routeUrl = root.$router.resolve(`financing/detail/${row.financeOrderApplyId}`);
      }
      window.open(routeUrl.href, '_blank');
    };

    // 模板下载
    const onDownload = async (type) => {
      if (type === 'operate') {
        await request('login', 'downLoadFile', {fileName: 'PLATFORM_OPERATION_MANUAL'});
      } else if (type === 'question'){
        await request('login', 'downLoadFile', {fileName: 'QUESTION_AND_ANSWER'});
      }
    };

    return {
      cardData,
      supplierData,
      financingBill,
      recentpaymentslip,
      financingProcess,
      loginstatus,
      tableConfig,
      suppliertabledata,
      checkBillDetail,
      checkfinancingDetail,
      clickMore,
      getBillOrderInfo,
      getFinanceOrderInfo,
      addComma,
      onDownload,
    };
  }
});
